module.exports = __webpack_public_path__ + "img/account_mb_01.e714498a.jpg";